module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1507-9db966059e4b1caf85432c9e93573290.png";